// extracted by mini-css-extract-plugin
export default {"SelectQuantityContainer":"SelectQuantity_SelectQuantityContainer__CEioB","SelectQuantityText":"SelectQuantity_SelectQuantityText__s4xxI"};